document.querySelectorAll('[data-faq-list]').forEach(list => {
  list.querySelectorAll('[data-faq-item]').forEach(item => {
    const trigger = item.querySelector('[data-faq-trigger]');
    if (!trigger) return;

    trigger.addEventListener('click', () => {
      const isOpen = item.classList.contains('is-open');

      // Close all items in this list
      list.querySelectorAll('[data-faq-item]').forEach(i => {
        i.classList.remove('is-open');
        const t = i.querySelector('[data-faq-trigger]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });

      // Open clicked item if it was closed
      if (!isOpen) {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });
});
